import axiosInstance from '@/services/axiosInstance'
import { AdditionalCostRequest, ObjectTypeCode, RequestStatusCode } from '@/types/AdditionalCostRequest'
import AdditionalCostRequestStatus from '@/constants/AdditionalCostRequestStatus'
import { PaginationParams } from '@/types/filter/PaginationParams'

export const apiGetAdditionalCostRequestList = async (params: {
  object_type?: ObjectTypeCode | null
  object_id?: number | null
  status?: RequestStatusCode | null
  code?: string | null
}) => {
  const response = await axiosInstance.get('/api/v1/additional-cost-requests/list', { params })
  return response.data
}

export const apiGetAdditionalCostRequestPagination = async (
  filters: {
    object_type?: ObjectTypeCode | null
    object_id?: number | null
    status?: RequestStatusCode | null
    code?: string | null
  },
  pagination: PaginationParams,
) => {
  const { page, size } = pagination
  const response = await axiosInstance.get('/api/v1/additional-cost-requests/pagination', {
    params: { ...filters, page, size },
  })
  return response.data
}

export const apiGetAdditionalCostRequest = async (id: number) => {
  const response = await axiosInstance.get(`/api/v1/additional-cost-requests/${id}`)
  return response.data
}

export const apiCreateAdditionalCostRequest = async (data: {
  object_id: number
  object_type: ObjectTypeCode
  amount: number
  reason: string
  input_arise?: string | null
  output_arise?: string | null
}) => {
  const response = await axiosInstance.post('/api/v1/additional-cost-requests', data, {
    headers: { 'Content-Type': 'application/json' },
  })
  return response.data
}

export const apiUpdateAdditionalCostRequest = async (
  id: number,
  data: {
    object_id: number
    object_type: ObjectTypeCode
    amount: number
    reason: string
    input_arise?: string | null
    output_arise?: string | null
  },
) => {
  const response = await axiosInstance.patch(`/api/v1/additional-cost-requests/${id}`, data, {
    headers: { 'Content-Type': 'application/json' },
  })
  return response.data
}

export const apiProcessAdditionalCostRequest = async (
  id: number,
  data: {
    status:
      | typeof AdditionalCostRequestStatus.PENDING_BOD
      | typeof AdditionalCostRequestStatus.REJECTED_BY_OCT
      | typeof AdditionalCostRequestStatus.APPROVED_BY_BOD
      | typeof AdditionalCostRequestStatus.REJECTED_BY_BOD
    note?: string | null
  },
) => {
  const response = await axiosInstance.patch(`/api/v1/additional-cost-requests/${id}/process`, data, {
    headers: { 'Content-Type': 'application/json' },
  })
  return response.data
}

export const apiDeleteAdditionalCostRequest = async (id: number) => {
  const response = await axiosInstance.delete(`/api/v1/additional-cost-requests/${id}`)
  return response.data
}

export const apiBulkDeleteAdditionalCostRequests = async (ids: number[]) => {
  const response = await axiosInstance.delete('/api/v1/additional-cost-requests/batch', {
    data: ids,
    headers: { 'Content-Type': 'application/json' },
  })
  return response.data
}

// Số đếm badge cạnh menu "Đề xuất phát sinh" - xem docs/receive-backend/0017-badge-de-xuat-phat-sinh.md.
export interface AdditionalCostRequestNotificationCounts {
  oct_count: number
  bod_count: number
  approved_count: number
}

export const apiGetAdditionalCostRequestNotificationCounts = async () => {
  const response = await axiosInstance.get('/api/v1/additional-cost-requests/notification-counts')
  return response.data
}

// Đánh dấu đã đọc TOÀN BỘ approved_count liên quan tới user hiện tại - gọi 1 lần ngay sau khi menu
// "Đề xuất phát sinh" mở xong (load /pagination xong), không cần id/body.
export const apiMarkAdditionalCostRequestNotificationsRead = async () => {
  const response = await axiosInstance.patch('/api/v1/additional-cost-requests/mark-notifications-read')
  return response.data
}

export type { AdditionalCostRequest }
